import { IApplicationState } from '../../types/redux';

export function selectPricingMethods(state: IApplicationState) {
  return state.promoInfo.pricing.methods;
}
